import { useBootstrapAuth } from "@/modules/auth";

export function AuthBootstrap() {
  useBootstrapAuth();
  return null;
}
